import { IDeleteFeriasUseCase } from "../../../presentation/useCases/delete/delete_ferias_use_case";
import { IRhRepository } from "../../repositories/rh_repository";

/**
 * DeleteFeriasUseCase
 */

export class DeleteFeriasUseCase implements IDeleteFeriasUseCase {
  constructor(
    private readonly repository: IRhRepository,
  ) { }

  async deleteFerias(idFerias: number): Promise<void> {
    await this.repository.deleteFerias(idFerias);
  }
}